import React from 'react';

const SocialWall = (props) => {
  return (
    <React.Fragment>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 25 25"
      >
        <g
          id="Group_920"
          data-name="Group 920"
          transform="translate(0)"
        >
          <path
            id="Path_197"
            data-name="Path 197"
            d="M22.878,14.969a.977.977,0,0,0-1.811.732l1.15,2.845L18.8,17.041a.977.977,0,0,0-.777,0,9.416,9.416,0,0,1-3.717.751c-5.228,0-8.74-4.093-8.74-7.917,0-4.365,3.921-7.917,8.74-7.917s8.74,3.551,8.74,7.917a7.964,7.964,0,0,1-.087,1.119.977.977,0,1,0,1.932.288A9.854,9.854,0,0,0,25,9.87a9.439,9.439,0,0,0-3.163-7.009A11.1,11.1,0,0,0,14.307,0a11.1,11.1,0,0,0-7.53,2.861A9.491,9.491,0,0,0,3.652,9.03,7.894,7.894,0,0,0,0,15.6a7.577,7.577,0,0,0,1.5,4.527L.072,23.657a.977.977,0,0,0,1.3,1.26L5.484,23.1a9.294,9.294,0,0,0,3.257.58c.024,0,.048,0,.072,0a9.243,9.243,0,0,0,4.595-1.245,8.407,8.407,0,0,0,2.954-2.877,11.237,11.237,0,0,0,2.029-.564L23.63,21.3a.977.977,0,0,0,1.3-1.26Z"
            transform="translate(0)"
            fill={props.color}
          />
          <circle
            id="Ellipse_69"
            data-name="Ellipse 69"
            cx="1.125"
            cy="1.125"
            r="1.125"
            transform="translate(12.81 10.489) rotate(-67.5)"
            fill={props.color}
          />
          <circle
            id="Ellipse_70"
            data-name="Ellipse 70"
            cx="1.125"
            cy="1.125"
            r="1.125"
            transform="translate(17.775 10.489) rotate(-67.5)"
            fill={props.color}
          />
          <circle
            id="Ellipse_71"
            data-name="Ellipse 71"
            cx="1.125"
            cy="1.125"
            r="1.125"
            transform="translate(7.844 10.489) rotate(-67.5)"
            fill={props.color}
          />
        </g>
      </svg>
    </React.Fragment>
  );
};

export default SocialWall;
